<template>
  <div class="col-12 col-sm-4 col-lg-3">
    <b-modal v-model="confirmRemoveModal"
      title="Remover Arquivo"
      class="modal-primary"
      @ok="removeFile">
      Deseja remover o banner #{{ instance.id }} {{ instance.heading }} do site ? Ao confirmar essa ação o banner não poderá ser recuperado.
      <br/>
    </b-modal>

    <div class="card">
      <div class="image-container d-flex justify-content-center align-items-center">
        <img class="card-img-top" :src="mediaInstance.url" blank alt="Banner" />
      </div>

      <div class="card-body banner-title">
        <h6 class="card-title">
          #{{ instance.id }} {{ instance.heading }}
        </h6>
      </div>

      <ul class="list-group list-group-flush">
        <li class="list-group-item">
          <span class="card-link">
            <i :class="{
              'fa mr-1': true,
              'fa-circle success': instance.status,
              'fa-circle-o': !instance.status
            }"></i>

            {{ instance.status ? 'Ativo' : 'Inativo' }}
          </span>
        </li>
        <li class="list-group-item">
          <router-link :to="{
              name: 'manageables.edit',
              params: { entity: 'bl-banners', id: instance.id }
            }" class="card-link">

            <i class="fa fa-edit"></i> Editar
          </router-link>
        </li>
        <li class="list-group-item">
          <a href="#" class="card-link" tabindex="-1" @click.stop.prevent="handleRemove">
            <i class="fa fa-trash-o"></i> Remover
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash'

export default {
  props: {
    instance: {
      type: Object,
      default () {
        return {
          media: []
        }
      }
    },

    http: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      //
      confirmRemoveModal: false
    }
  },

  computed: {
    mediaInstance () {
      if (!isEmpty(this.instance.media)) {
        return this.instance.media[0]
      }

      return {}
    }
  },

  methods: {
    removeFile () {
      const self = this
      this.$Progress.start()
      self.confirmRemoveModal = false

      self.http.destroy(self.instance.id)
        .then((res) => {
          self.$emit('item-removed', self.instance)
          self.$toasted.success('Banner removido com sucesso')
        })
    },

    handleRemove () {
      if (this.instance.id) {
        this.confirmRemoveModal = true
        return null
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  .card
    .image-container
      height: 150px
      background-color: #b3b3b3

      img
        max-height: 100%
        max-width: 100%
        width: auto

    .banner-title
      height: 120px

  i.success
    color: #4dbd74
</style>



// WEBPACK FOOTER //
// src/components/forms/Bl/BannerCard.vue